import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';
import TextHeadingTwo from '../atoms/TextHeadingTwo';
import Icon from '../atoms/Icon';
import FormChangeName from '../organisms/FormChangeName';
import FormDeleteIntent from '../organisms/FormDeleteIntent';

const ESCAPE_KEY = 27;
const ACTIVE_CLASS = 'modal--active';

//Returning the component
class SubSubjectTitle extends Component {
	state = { value: this.props.subSubjectTitle }

	handleEdit = (showDelete) => {
		document.addEventListener('click', this.handlePassiveClose, false);
		document.addEventListener('keydown', this.handlePassiveClose, false);
		this.setState({ modalClass: ACTIVE_CLASS, showDelete });
	}

	handleChange = ({ target: { value } }) => this.setState({ value })

	handleSubmit = (e) => {
		e.preventDefault();
		this.handleClose();
		this.props.handleSubmit(this.props.id, this.state.value);
	}

	handlePassiveClose = ({ target: { className }, keyCode }) => {
		const isClosing = className.includes(ACTIVE_CLASS) || keyCode === ESCAPE_KEY;
		if (isClosing) {
			this.setState({ value: this.props.subSubjectTitle });
			this.handleClose();
		}
	}

	handleClose = () => {
		this.setState({ modalClass: '', showDelete: false });
		document.removeEventListener('click', this.handleOutsideClick, false);
		document.removeEventListener('keydown', this.handleOutsideClick, false);
	}

	render() {
		const { value, modalClass, showDelete } = this.state;
		return (
			<div className="SubSubjectTitle">
				<div className="subSubjectTitle__wrapper">
					<div className="SubSubjectTitle__name">
						<TextHeadingTwo text={value} />
						</div>
						<div className="SubSubjectTitle__option">
							<Icon classType="icon--button SubSubjectTitle__optionButton fa-pencil fa-lg" role="button" onClick={() => this.handleEdit(false)} />
							<Icon classType="icon--button SubSubjectTitle__optionButton fa-trash fa-lg" role="button" onClick={() => this.handleEdit(true)} />
						</div>
				</div>
				<div style={{ color: 'black' }}>
				<FormChangeName
						modalClass={showDelete ? '': modalClass}
						onChange={this.handleChange}
						value={value}
						onClick={this.handleSubmit}
						onClose={this.handleClose}
						heading='Change name'
						paragraph='Rename the conversation'
						buttonLabel='Update'
					/>
				</div>
				<div style={{ color: 'black' }}>
				<FormDeleteIntent
						modalClass={showDelete ? modalClass : ''}
						value={value}
						id={this.props.id}
						onClickCancel={this.handleClose}
					/>
				</div>
			</div>
		)
	}
}

SubSubjectTitle.propTypes = {
	SubSubjectTitle: PropTypes.string
}

export default SubSubjectTitle;


// WEBPACK FOOTER //
// ./src/redux/components/molecules/SubSubjectTitle.jsx